
import Vue from 'vue';
import Button from '~/components/builders/Base/Button.vue';
import { VFairUser } from '~/services/types/vfair';
import VfairInviteCodeDialog from './VFairInviteCodeDialog.vue';

export default Vue.extend({
    components: { Button },
    name: 'VFairInvite',
    props: {
        vFairUser: {
            type: Object,
            default: () => ({} as VFairUser),
        },
        isInvited: {
            type: Boolean,
            required: true,
        },
    },
    methods: {
        showCodeDialog(): void {
            (this as any).$interfaces.dialogModal.openModal({
                title: this.$t('vfair.inviteCode'),
                component: VfairInviteCodeDialog,
                actions: [],
                clickawayOff: true,
                props: {
                    vFairUser: this.vFairUser,
                },
                onClose: ({ res }: { res: any }) => res(),
            });
        },
    },
});
